// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__adnyO","item":"styles_item__xi_Ma","list--pill":"styles_list--pill__d0xB5","fadeInOut":"styles_fadeInOut__t8VE5","loader":"styles_loader__Mmpoh"};